// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"styles_tabsContainer__EHbW7"};